export class CancelManager {
  private static instance: CancelManager;
  private isCancelled: boolean = false;

  private constructor() {}

  public static getInstance(): CancelManager {
    if (!CancelManager.instance) {
      CancelManager.instance = new CancelManager();
    }
    return CancelManager.instance;
  }

  public cancel(): void {
    this.isCancelled = true;
  }

  public reset(): void {
    this.isCancelled = false;
  }

  public isCancelRequested(): boolean {
    return this.isCancelled;
  }

  public checkCancelled(): void {
    if (this.isCancelled) {
      throw new CancelError();
    }
  }
}

export class CancelError extends Error {
  constructor(message: string = "処理がキャンセルされました。") {
    super(message);
    this.name = "CancelError";
  }
}
